import api from "@/api/asistente";

// Asistente IA: habilitación por empresa (la decide el backend, AsistenteEmpresa).
// Se consulta una vez por sesión al entrar al contexto empresa; hasta que responde,
// `habilitado` es null y el botón no se muestra.
export default {
  namespaced: true,
  state: () => ({
    habilitado: null,
    estado: null,
  }),
  mutations: {
    SET_ESTADO(state, estado) {
      state.estado = estado;
      state.habilitado = !!(estado && estado.habilitado);
    },
  },
  actions: {
    async cargarEstado({ commit }) {
      try {
        const { data } = await api.estado();
        commit("SET_ESTADO", data);
      } catch (e) {
        commit("SET_ESTADO", { habilitado: false });
      }
    },
  },
};
